import _debounce from 'lodash/debounce';
import vngageCodemirrorXmlTemplate from './vngageCodemirrorXmlTemplate';

export default function ($window, jshint, $timeout) {
    'ngInject';

    var validateScriptTimeoutInMilliseconds = 800,
        notifications = [];

    return {
        replace: true,
        restrict: 'A',
        require: ['^form', '^ngModel'],
        scope: {
            model: '=ngModel',
			refresh: '='
        },
        templateUrl: vngageCodemirrorXmlTemplate,
        link: function (scope, element, attrs, ctrls) {
            scope.form = ctrls[0];
            var ngModel = ctrls[1];

            scope.$watch('model', function (newValue) {
                if (scope.form.$pristine) {
                    editor.doc.setValue(newValue);
                }
            });

            var editor = element.next()[0].CodeMirror;
            $timeout(function() {
                editor.doc.setValue(scope.model);
            }, 0);

            editor.on('change', _debounce(change, validateScriptTimeoutInMilliseconds));

            function change() {

                editor.operation(function() {});

                setModelValidity();
                setScrollPosition();
            }

            function setModelValidity() {

                scope.$apply(function(){
                    scope.model = editor.getValue();
                });
            }

            function setScrollPosition() {
                var info = editor.getScrollInfo();
                var after = editor.charCoords({ line: editor.getCursor().line + 1, ch: 0 }, 'local').top;
                if (info.top + info.clientHeight < after) {
                    editor.scrollTo(null, after - info.clientHeight + 3);
                }
            }

			scope.$watch('refresh', (update) => {
				/*
					If incoming parameter 'refresh' is changed (and not falsy), editor will be refreshed.
					ui-CodeMirror has a bug that will make the editor blank if it's not visible on init.
					E.g. when placed in a tab that is not focused/visible from start (when navigating to the tab containing the code mirror component, it will be blank until it gets focus or window is resized).
					To fix, the tab containing the component could set it's "active"-attribute, like "<tab heading="White label" active="vm.whiteLabelTabActive">",
					and the codemirror-component can set it's "refresh"-attribute to the same like:
					<textarea
							name="customXml"
							vngage-codemirror-xml
							data-refresh="vm.TabActive"
							data-ng-model="vm.code">
					</textarea>
					That way, 'refresh' will -> 'true' when the tab is selected, the editor will be refreshed and content will be visible

					"refresh" can also be set to a timestamp to trigger updates when the editor's content is set
				*/
				if (update && editor) {
					$timeout(() => {
						editor.refresh()
					}, 0);
				}
			}, true); // <--- Important: We need to watch incoming scope-variables with deep-checking in directives!!!!

		}
    };
};
